import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

window.initializeTooltip = function () {
  tippy("a[rel=tooltip]", {
    content(reference) {
      const content =
        reference.getAttribute("title") ??
        reference.getAttribute("data-title") ??
        "";
      reference.removeAttribute("title");
      reference.setAttribute("data-title", content);

      return content.replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");
    },
    allowHTML: true,
  });
};
